var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',[_vm._v("MemorizeView")]),_c('br'),_c('ButtonPlain',{attrs:{"label":"Start quiz"},on:{"click":function($event){return _vm.startQuiz()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }